import React from 'react';
import CategoryTemplate from 'templates/category';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const CategoryPage = () => {
  const [t] = useTranslation();
  const image = useStaticQuery(graphql`
    query {
      strapiCategory(slug: { eq: "eventhjalp" }) {
        image {
          childImageSharp {
            fluid(maxHeight: 1024, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);
  return (
    <CategoryTemplate
      heading={t('page--event.heading')}
      subheading={t('page--event.subheading')}
      buttonLabel={t('page--event.buttonLabel')}
      content={t('page--event.content')}
      image={image.strapiCategory.image}
      ctaTitle={t('page--event.ctaTitle')}
      seoTitle={t('page--event.seoTitle')}
      seoDescription={t('page--event.seoDescription')}
    />
  );
};
export default CategoryPage;
